// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.menu{
    font-weight: 600;
    font-family: 'Montserrat',sans-serif;
    font-size: 20px;
}

.menu-header{
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.card {
  width: 100%;
  height: 60px;
  display: flex;
  padding: 0px 24px;
  justify-content: center;
  background: #fff;
  border-radius: 12px;
  border-left: 6px solid #C39B22;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.12);
  margin-top: 12px;
}

.card-inner{
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.menu-name{
    font-size: 16px;
    font-weight: 600;
    font-family: 'Montserrat',sans-serif;
    margin-top: 12px;
}

.page-item .page-link {
  color: #C39B22;
  border: 1px solid #C39B22;
  background-color: #fff;
  font-weight: 500;
  margin: 0 4px;
  border-radius: 8px;
}

.page-item.active .page-link {
  background-color: #C39B22;
  border-color: #C39B22;
  color: #fff;
}

.page-item:not(.active) .page-link:hover {
  background-color: #C39B22;
  color: #fff;
}

.page-item.disabled .page-link {
  color: #ccc;
  border-color: #ddd;
  background-color: #f8f9fa;
  cursor: not-allowed;
}

.loader{
    display: flex;
    justify-content: center;
    margin: 100px auto;
}

.action-circle {
  width: 30px;
  height: 30px;
  border-radius: 50%;
  background-color: #C39B22;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  margin-right: 8px;
}

.action-circle svg {
  color: #fff;
}

.action-pill {
  height: 30px;
  padding: 0 12px;
  border-radius: 18px;
  background-color: #C39B22;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  cursor: pointer;
  margin-right: 8px;
  color: #fff;
  font-size: 14px;
  font-weight: 500;
}

.action-pill svg {
  color: #fff;
}

.action-circle:hover,
.action-pill:hover {
  background-color: #b0891f;
}



`, "",{"version":3,"sources":["webpack://./src/Pages/Menu/menu.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;IAChB,oCAAoC;IACpC,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,iBAAiB;EACjB,uBAAuB;EACvB,gBAAgB;EAChB,mBAAmB;EACnB,8BAA8B;EAC9B,0CAA0C;EAC1C,gBAAgB;AAClB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,oCAAoC;IACpC,gBAAgB;AACpB;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,sBAAsB;EACtB,gBAAgB;EAChB,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,kBAAkB;AACtB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,yBAAyB;EACzB,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,iBAAiB;EACjB,WAAW;EACX,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,WAAW;AACb;;AAEA;;EAEE,yBAAyB;AAC3B","sourcesContent":[".menu{\n    font-weight: 600;\n    font-family: 'Montserrat',sans-serif;\n    font-size: 20px;\n}\n\n.menu-header{\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n}\n\n.card {\n  width: 100%;\n  height: 60px;\n  display: flex;\n  padding: 0px 24px;\n  justify-content: center;\n  background: #fff;\n  border-radius: 12px;\n  border-left: 6px solid #C39B22;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.12);\n  margin-top: 12px;\n}\n\n.card-inner{\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n}\n\n.menu-name{\n    font-size: 16px;\n    font-weight: 600;\n    font-family: 'Montserrat',sans-serif;\n    margin-top: 12px;\n}\n\n.page-item .page-link {\n  color: #C39B22;\n  border: 1px solid #C39B22;\n  background-color: #fff;\n  font-weight: 500;\n  margin: 0 4px;\n  border-radius: 8px;\n}\n\n.page-item.active .page-link {\n  background-color: #C39B22;\n  border-color: #C39B22;\n  color: #fff;\n}\n\n.page-item:not(.active) .page-link:hover {\n  background-color: #C39B22;\n  color: #fff;\n}\n\n.page-item.disabled .page-link {\n  color: #ccc;\n  border-color: #ddd;\n  background-color: #f8f9fa;\n  cursor: not-allowed;\n}\n\n.loader{\n    display: flex;\n    justify-content: center;\n    margin: 100px auto;\n}\n\n.action-circle {\n  width: 30px;\n  height: 30px;\n  border-radius: 50%;\n  background-color: #C39B22;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  margin-right: 8px;\n}\n\n.action-circle svg {\n  color: #fff;\n}\n\n.action-pill {\n  height: 30px;\n  padding: 0 12px;\n  border-radius: 18px;\n  background-color: #C39B22;\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  cursor: pointer;\n  margin-right: 8px;\n  color: #fff;\n  font-size: 14px;\n  font-weight: 500;\n}\n\n.action-pill svg {\n  color: #fff;\n}\n\n.action-circle:hover,\n.action-pill:hover {\n  background-color: #b0891f;\n}\n\n\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
